import { BookmarkIcon } from './BookmarkIcon';

/**
 * author: Google
 * id 690787DD-F7B0-4D32-A668-32657D3A3AE8
 * name bookmark
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark.svg
 * tags
 */
export const TurnedInIcon = BookmarkIcon;
export default TurnedInIcon